import script from "./ProjectExpenseAllocationsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectExpenseAllocationsPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectExpenseAllocationsPage.vue?vue&type=style&index=0&id=15530b3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15530b3e"]])

export default __exports__